import React, { useState } from "react";
import {Outlet, Link } from "react-router-dom";
import './Datenschutz.css';
import Footer from "../components/Footer";

const Datenschutz = () => {

    const [isOpen, setIsOpen] = useState(false);
        
          const toggleMobileMenu = () => {
            setIsOpen(!isOpen);
          };

    return(
        <section className="container-datenschutz"
          style={{ overflow: 'hidden'}} 
        >
                <div className="navbar-datenschutz"
                style={{
                position: 'relative',
                minHeight: '100%',
                width: '100%',
                backgroundImage: 'url(/assets/datenschutz-hero.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}>
                    {/* Burger Button (mobile only) */}
                    <div className="burger-button" onClick={toggleMobileMenu}>
                        <div className="bar"></div>
                        <div className="bar"></div>
                        <div className="bar"></div>
                    </div>
        
                    {/* Mobile Menu */}
                    <nav className={`mobile-menu ${isOpen ? "open" : ""}`}>
                        <Link to="/überUns" onClick={toggleMobileMenu}>Über Uns</Link>
                        <Link to="/leistungen" onClick={toggleMobileMenu}>Leistungen</Link>
                        <Link to="/aktuelles" onClick={toggleMobileMenu}>Aktuelles</Link>
                        <Link to="/kontakt" onClick={toggleMobileMenu}>Kontakt</Link>
                        <Link to="/impressum" onClick={toggleMobileMenu}>Impressum</Link>
                        <Link to="/" onClick={toggleMobileMenu}>Home</Link>
                        <Link to="/blog" onClick={toggleMobileMenu}>Blog</Link>
                    </nav>
        
                    {/* Hexagon Nav (desktop) */}
                    <section className="hero--inner">
                        <div className="hexagon-wrapper" id="hexagon-über-uns"><div className="hexagon"><i><Link to="/überUns" className="link">Über Uns</Link></i></div></div>
                        <div className="hexagon-wrapper" id="hexagon-leistungen"><div className="hexagon"><i><Link to="/leistungen" className="link">Leistungen</Link></i></div></div>
                        <div className="hexagon-wrapper" id="hexagon-aktuelles"><div className="hexagon"><i><Link to="/aktuelles" className="link">Aktuelles</Link></i></div></div>
                        <div className="hexagon-wrapper" id="hexagon-kontakt"><div className="hexagon"><i><Link to="/kontakt" className="link">Kontakt</Link></i></div></div>
                        <div className="hexagon-wrapper" id="hexagon-impressum"><div className="hexagon"><i><Link to="/impressum" className="link">Impressum</Link></i></div></div>
                        <div className="hexagon-wrapper" id="hexagon-datenschutz"><div className="hexagon"><i><Link to="/" className="link">Home</Link></i></div></div>
                        <div className="hexagon-wrapper" id="hexagon-blog"><div className="hexagon"><i><Link to="/blog" className="link">Blog</Link></i></div></div>
                    </section>
                </div>

                <div
                style={{
                position: 'relative',
                minHeight: '100%',
                width: '100%',
                backgroundImage: 'url(/assets/datenschutz-body.png)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                zIndex: 0,
            }}>
                    <div className="datenschutz-container">
                    <h1 className="datenschutz-heading">Datenschutzerklärung</h1>

                    <section className="datenschutz-section">
                        <h2>1. Datenschutz auf einen Blick</h2>
                        <p>
                        Der Schutz Ihrer Daten ist uns wichtig. Diese Datenschutzerklärung informiert Sie darüber, welche personenbezogenen Daten wir erheben, wie wir sie verwenden und welche Rechte Sie haben.
                        </p>
                    </section>

                    <section className="datenschutz-section">
                        <h2>2. Verantwortlicher</h2>
                        <p>
                        <strong>LAM Autoservice</strong><br />
                        Schwarzbach 152<br />
                        42277 Wuppertal<br />
                        E-Mail: <a href="mailto:info@lam-autoservice.de">info@lam-autoservice.de</a><br />
                        Telefon: +49 176 72987527
                        </p>
                    </section>

                    <section className="datenschutz-section">
                        <h2>3. Erhebung und Speicherung personenbezogener Daten</h2>
                        <p>
                        Wir erheben personenbezogene Daten nur, wenn Sie uns diese im Rahmen einer Anfrage oder über das Kontaktformular freiwillig mitteilen.
                        </p>
                        <p>Erhobene Daten können sein:</p>
                        <ul>
                        <li>Name</li>
                        <li>E-Mail-Adresse</li>
                        <li>Telefonnummer</li>
                        <li>Nachricht/Inhalt</li>
                        </ul>
                    </section>

                    <section className="datenschutz-section">
                        <h2>4. Zweck der Datenverarbeitung</h2>
                        <p>
                        Die Verarbeitung erfolgt zur Bearbeitung Ihrer Anfrage, zur Terminvereinbarung und ggf. zur Erfüllung vertraglicher Pflichten.
                        </p>
                    </section>

                    <section className="datenschutz-section">
                        <h2>5. Weitergabe an Dritte</h2>
                        <p>
                        Eine Weitergabe Ihrer Daten an Dritte erfolgt nicht, es sei denn, dies ist zur Vertragserfüllung erforderlich oder wir sind gesetzlich dazu verpflichtet.
                        </p>
                    </section>

                    <section className="datenschutz-section">
                        <h2>6. Ihre Rechte</h2>
                        <p>Sie haben das Recht auf:</p>
                        <ul>
                        <li>Auskunft über Ihre gespeicherten Daten</li>
                        <li>Berichtigung unrichtiger Daten</li>
                        <li>Löschung oder Einschränkung der Verarbeitung</li>
                        <li>Widerspruch gegen die Verarbeitung</li>
                        <li>Datenübertragbarkeit</li>
                        </ul>
                        <p>Bitte kontaktieren Sie uns dazu unter der oben genannten Adresse.</p>
                    </section>

                    <section className="datenschutz-section">
                        <h2>7. Änderungen dieser Erklärung</h2>
                        <p>
                        Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen. Gültig ist jeweils die zum Zeitpunkt des Besuchs abrufbare Fassung.
                        </p>
                    </section>
                    </div>
                </div>
                <div className="footer-homepage">
                < Footer />
                </div>
                <Outlet />
            </section>
    );
};

export default Datenschutz;

/**
 * <div class="hexagon-wrapper">
                <div class="hexagon" id="hexagon-über-uns">
                    <i class="fab-Über-Uns"><Link to="/überUns" class="link">Über Uns</Link></i>
                </div>
                </div>
                <div class="hexagon-wrapper" id="hexagon-leistungen">
                    <div class="hexagon" >
                        <i class="fab-Leistungen"><Link to="/leistungen" class="link">Leistungen</Link></i>
                    </div>
                </div>
                <div class="hexagon-wrapper" id="hexagon-aktuelles">
                    <div class="hexagon">
                        <i class="fab-Aktuelles"><Link to="/aktuelles" class="link">Aktuelles</Link></i>
                    </div>
                </div>
                <div class="hexagon-wrapper" id="hexagon-kontakt">
                    <div class="hexagon">
                        <i class="fab-Kontakt"><Link to="/" class="link">Home</Link></i>
                    </div>
                </div>
                <div class="hexagon-wrapper" id="hexagon-impressum">
                    <div class="hexagon">
                        <i class="fab-Impressum"><Link to="/impressum" class="link">Impressum</Link></i>
                    </div>
                </div>
                <div class="hexagon-wrapper" id="hexagon-datenschutz">
                    <div class="hexagon">
                        <i class="fab-datenschutz"><Link to="/kontakt" class="link">Kontakt</Link></i>
                    </div>
                </div>
                <div class="hexagon-wrapper" id="hexagon-blog">
                    <div class="hexagon">
                        <i class="fab-blog"><Link to="/blog" class="link">Blog</Link></i>
                    </div>
                </div>
 */